// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { BrowserRouter, Switch, Redirect, Route } from 'react-router-dom';

import { useAuth } from '../hooks/auth.context';
import { SignIn, Reports, NotFound } from '../pages';
import BillingRoutes from './billing.routes';
import CollaboratorsRoutes from './collaborators.routes';
import IBOSSRoutes from './iboss.routes';
import ILABRoutes from './ilab.routes';
// import CouponsRoutes from './coupons.routes';
import CustomRoute from './types/custom.route';
import UserRoutes from './user.routes';

const Routes = () => {
  const { user } = useAuth();
  const isAuthenticated = !user;

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/">
          {isAuthenticated ? <SignIn /> : <Redirect to="/users" />}
        </Route>

        {isAuthenticated && <CustomRoute component={NotFound} />}

        <CustomRoute
          isPrivate={isAuthenticated}
          path="/users"
          component={UserRoutes}
        />
        <CustomRoute
          isPrivate={isAuthenticated}
          path="/ilab"
          component={ILABRoutes}
        />
        <CustomRoute
          isPrivate={isAuthenticated}
          path="/iboss"
          component={IBOSSRoutes}
        />
        <CustomRoute
          isPrivate={isAuthenticated}
          path="/collaborators"
          component={CollaboratorsRoutes}
        />
        <CustomRoute
          isPrivate={isAuthenticated}
          path="/billing"
          component={BillingRoutes}
        />
        <CustomRoute
          isPrivate={isAuthenticated}
          path="/reports"
          exact
          component={Reports}
        />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
